import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { logIn, resetLogIn, emptyReduxUser } from '../../actions/userAction';
import { emptyReduxSubscription } from "../../actions/subscriptionAction";
import GridShape from "../../components/common/GridShape";
import Input from "../../components/form/input/InputField";
import Label from "../../components/form/Label";
import { Link } from "react-router";
import { ChevronLeftIcon, EyeCloseIcon, EyeIcon } from "../../icons";
import Checkbox from "../../components/form/input/Checkbox";
import Button from "../../components/ui/button/Button";
import PageMeta from "../../components/common/PageMeta";
import Alert from "../../components/ui/alert/Alert";

export default function SignIn() {

  const [email, setEmail] = useState(false);
  const [password, setPassword] = useState(false);

  const [errorEmail, setErrorEmail] = useState(false);
  const [errorPassword, setErrorPassword] = useState(false);

  const [showPassword, setShowPassword] = useState(false);
  const [isChecked, setIsChecked] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [isActive, setActive] = useState(false);
  const [showLoginLoader, setShowLoginLoader] = useState(false);
  const [showLoginError, setShowLoginError] = useState(false);
  const LogInRes = useSelector(state => state.userReducer.getLogin);
  
  /*const handleLoginSubmit = async (event) => {
        event.preventDefault();
        setActive(true); 
        //setTimeout(() => {
              const email = event.target.elements.email.value;
              const password = event.target.elements.password.value;
              console.log(password, email);
              if(password == ""){
                    console.log('fill all fields');
                    return;
              }
              let data = {
                    "email": email,
                    "password": password
              }
              setShowLoginLoader(true);
              dispatch(logIn(data));
        //}, 1500);
  }*/

  useEffect(() => {
    setTimeout(()=>{
      dispatch(emptyReduxUser());
      dispatch(emptyReduxSubscription());
    }, 1000);
  }, []);

  useEffect(() => {
        setShowLoginLoader(false);
        console.log(LogInRes);
        if (LogInRes.statusCode == 200) {
            console.log("Entered effect");
              localStorage.id = LogInRes.data.id;
              localStorage.name = LogInRes.data.name;
              localStorage.username = LogInRes.data.username;
              localStorage.email = LogInRes.data.email;
              localStorage.role = parseInt(LogInRes.data.role);
              localStorage.token = LogInRes.data.token;
              dispatch(resetLogIn());
              navigate("/");
        }else if(LogInRes.statusCode == 400){
              //toast.error(LogInRes.message, {autoClose:5000});
              setShowLoginError(LogInRes.message);

              setTimeout(()=>{
                setShowLoginError(false);
              },5000);

              setActive(false);
        }
        /*else{
              setShowLoginError("Something Went wrong..! Please try again.");
              setTimeout(()=>{
                setShowLoginError(false);
              },5000);
              setActive(false);
        }*/
  }, [LogInRes]);

  const handleChange = (input, event) => {
    
    var value = event.target.value;

    if(input == "email"){
      setEmail(value);
    }

    if(input == "password"){
      setPassword(value);
    }
  };


  const validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };

  const handleLoginSubmit = (e) => {
    e.preventDefault();

    setErrorEmail(false);
    setErrorPassword(false);

    var err = [];
    if(email.replace(/\s/g, '') == ""){
      err.push("Email");
      setErrorEmail("This field is required.");
    }
    else if(!validateEmail(email)){
      err.push("Email");
      setErrorEmail("Please provide valid email address.");
    }

    if(password.replace(/\s/g, '') == ""){
      err.push("password");
      setErrorPassword(true);
    }

    
    if(err.length === 0){

      let data = {
        "email": email,
        "password": password
      }
      setShowLoginLoader(true);
      dispatch(logIn(data));
    }
  };
  
  return (
    <>
      <PageMeta
        title="Chit Fund Management System"
        description="Chit Fund Management system"
      />
      <div className="relative flex w-full h-screen px-4 py-6 overflow-hidden bg-white z-1 dark:bg-gray-900 sm:p-0">
        <div className="flex flex-col flex-1 p-6 rounded-2xl sm:rounded-none sm:border-0 sm:p-8">
          
          <div className="flex flex-col justify-center flex-1 w-full max-w-md mx-auto">
            <div>
              <div className="mb-5 sm:mb-8">
                <h1 className="mb-2 font-semibold text-gray-800 text-title-sm dark:text-white/90 sm:text-title-md">
                  Sign In
                </h1>
                <p className="text-sm text-gray-500 dark:text-gray-400">
                  Enter your email and password to sign in!
                </p>
              </div>
              <div>
                
                <form onSubmit={handleLoginSubmit}>
                {(
                  showLoginError

                  ? 
                  <div className="mb-5 sm:mb-8">
                  <Alert
                    variant="error"
                    title="Warning"
                    message={showLoginError}
                    showLink={false}
                  />
                  </div>
                  : 
                  
                  null
                )}
                  <div className="space-y-6">
                    <div>
                      <Label>
                        Email <span className="text-error-500">*</span>{" "}
                      </Label>
                      <Input 
                        type="email" 
                        name="email" 
                        id="email" 
                        placeholder="Enter You Email"
                        error={errorEmail} 
                        onChange={(e) => handleChange("email", e)} 
                        hint={errorEmail ? errorEmail : ""} 
                      />
                    </div>
                    <div>
                      <Label>
                        Password <span className="text-error-500">*</span>{" "}
                      </Label>
                      <div className="relative">
                        <Input
                          type={showPassword ? "text" : "password"}
                          placeholder="Enter your password"
                          name="password" id="password"
                          error={errorPassword} 
                          onChange={(e) => handleChange("password", e)} 
                          hint={errorPassword ? "This field is required." : ""} 
                        />
                        <span
                          onClick={() => setShowPassword(!showPassword)}
                          className="absolute z-30 -translate-y-1/2 cursor-pointer right-4 top-1/2"
                        >
                          {showPassword ? (
                            <EyeIcon className="fill-gray-500 dark:fill-gray-400" />
                          ) : (
                            <EyeCloseIcon className="fill-gray-500 dark:fill-gray-400" />
                          )}
                        </span>
                      </div>
                    </div>
                    <div className="flex items-center justify-between">
                      <div className="flex items-center gap-3">
                        <Checkbox checked={isChecked} onChange={setIsChecked} />
                        <span className="block font-normal text-gray-700 text-theme-sm dark:text-gray-400">
                          Keep me logged in
                        </span>
                      </div>
                      <Link
                        to="/"
                        className="text-sm text-brand-500 hover:text-brand-600 dark:text-brand-400"
                      >
                        Forgot password?
                      </Link>
                    </div>
                    <div>
                      <Button className="w-full" size="sm">
                        Sign in
                        {(
                          showLoginLoader 

                          ? 

                          <span class="animate-spin" ><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><circle opacity="0.5" cx="10" cy="10" r="8.75" stroke="white" stroke-width="2.5"></circle><mask id="path-2-inside-1_3755_26472" fill="white"><path d="M18.2372 12.9506C18.8873 13.1835 19.6113 12.846 19.7613 12.1719C20.0138 11.0369 20.0672 9.86319 19.9156 8.70384C19.7099 7.12996 19.1325 5.62766 18.2311 4.32117C17.3297 3.01467 16.1303 1.94151 14.7319 1.19042C13.7019 0.637155 12.5858 0.270357 11.435 0.103491C10.7516 0.00440265 10.179 0.561473 10.1659 1.25187V1.25187C10.1528 1.94226 10.7059 2.50202 11.3845 2.6295C12.1384 2.77112 12.8686 3.02803 13.5487 3.39333C14.5973 3.95661 15.4968 4.76141 16.1728 5.74121C16.8488 6.721 17.2819 7.84764 17.4361 9.02796C17.5362 9.79345 17.5172 10.5673 17.3819 11.3223C17.2602 12.002 17.5871 12.7178 18.2372 12.9506V12.9506Z"></path></mask><path d="M18.2372 12.9506C18.8873 13.1835 19.6113 12.846 19.7613 12.1719C20.0138 11.0369 20.0672 9.86319 19.9156 8.70384C19.7099 7.12996 19.1325 5.62766 18.2311 4.32117C17.3297 3.01467 16.1303 1.94151 14.7319 1.19042C13.7019 0.637155 12.5858 0.270357 11.435 0.103491C10.7516 0.00440265 10.179 0.561473 10.1659 1.25187V1.25187C10.1528 1.94226 10.7059 2.50202 11.3845 2.6295C12.1384 2.77112 12.8686 3.02803 13.5487 3.39333C14.5973 3.95661 15.4968 4.76141 16.1728 5.74121C16.8488 6.721 17.2819 7.84764 17.4361 9.02796C17.5362 9.79345 17.5172 10.5673 17.3819 11.3223C17.2602 12.002 17.5871 12.7178 18.2372 12.9506V12.9506Z" stroke="white" stroke-width="4" mask="url(#path-2-inside-1_3755_26472)"></path></svg></span>

                          : 
                          
                          null
                        )}
                      </Button>
                    </div>
                  </div>
                </form>

                {<div className="mt-5">
                  <p className="text-sm font-normal text-center text-gray-700 dark:text-gray-400 sm:text-start">
                    Don't have an account? {""}
                    <Link
                      to="/signup"
                      className="text-brand-500 hover:text-brand-600 dark:text-brand-400"
                    >
                      Sign Up
                    </Link>
                  </p>
                </div>}
              </div>
            </div>
          </div>
        </div>
        <div className="relative items-center justify-center flex-1 hidden p-8 z-1 bg-brand-950 dark:bg-white/5 lg:flex">
          {/* <!-- ===== Common Grid Shape Start ===== --> */}
          <GridShape />
          <div className="flex flex-col items-center max-w-xs">
            <Link to="/" className="block mb-4">
              {/* <img src="./images/logo/gold_chit_fund.png" alt="Logo" /> */}
              <span className="text-[28px] font-bold text-white">
              CHIT MAX FUND
              </span>
            </Link>
            <p className="text-center text-gray-400 dark:text-white/60">
              Chit fund management system
            </p>
          </div>
        </div>
      </div>
    </>
  );
}
